import React from 'react';
import CollectionPage from '../shared/CollectionPage';

const boardGameWishlistEditFields = [
  { name: 'name', label: 'Game Name', type: 'text', required: true, gridProps: { xs: 12 } },
  { name: 'designers', label: 'Designer(s)', type: 'text', required: false, gridProps: { xs: 12, sm: 6 } },
  { name: 'publisher', label: 'Publisher', type: 'text', required: false, gridProps: { xs: 12, sm: 6 } },
  { name: 'year', label: 'Year', type: 'number', required: false, gridProps: { xs: 12, sm: 6 } },
  { name: 'minPlayers', label: 'Min Players', type: 'number', required: false, gridProps: { xs: 6, sm: 3 } },
  { name: 'maxPlayers', label: 'Max Players', type: 'number', required: false, gridProps: { xs: 6, sm: 3 } },
  { name: 'playingTime', label: 'Playing Time (min)', type: 'number', required: false, gridProps: { xs: 12, sm: 6 } },
  { name: 'minAge', label: 'Min Age', type: 'number', required: false, gridProps: { xs: 12, sm: 6 } },
  { name: 'category', label: 'Category', type: 'text', required: false, gridProps: { xs: 12, sm: 6 } },
  { name: 'genre', label: 'Genre/Mechanic', type: 'text', required: false, gridProps: { xs: 12, sm: 6 } },
  {
    name: 'priority', label: 'Priority', type: 'select', required: false,
    options: ['Low', 'Medium', 'High'],
    gridProps: { xs: 12, sm: 6 }
  },
  { name: 'rating', label: 'Rating', type: 'rating', required: false, gridProps: { xs: 12 } },
  { name: 'description', label: 'Description', type: 'textarea', required: false, gridProps: { xs: 12 } },
  { name: 'imageUrl', label: 'Image URL', type: 'text', required: false, gridProps: { xs: 12 } },
  { name: 'notes', label: 'Notes', type: 'textarea', required: false, gridProps: { xs: 12 } }
];

const BoardGameWishlistDashboard = () => {
  const boardGameRenderProps = {
    getImageUrl: (item) => item.imageUrl,
    getItemName: (item) => item.name,
    getItemSubtitle: (item) => [
      item.designers || null,
      item.year ? `${item.year}` : null
    ].filter(Boolean).join(' • ') || 'Board Game',
    getItemDetails: (item) => [
      item.category || null,
      item.minPlayers && item.maxPlayers
        ? `${item.minPlayers}–${item.maxPlayers} players`
        : item.minPlayers ? `${item.minPlayers}+ players` : null,
      item.playingTime ? `${item.playingTime} min` : null
    ].filter(Boolean).join(' • ')
  };

  return (
    <CollectionPage
      collectionType="board-game-wishlist"
      title="Board Game Wishlist"
      renderProps={boardGameRenderProps}
      editFields={boardGameWishlistEditFields}
      isWishlist={true}
    />
  );
};

export default BoardGameWishlistDashboard;
